export default __webpack_public_path__ + "static/media/enviroment.1a33daf6.webp";